import React, { FC, useEffect } from 'react';
import { sendMobileLoadedNotification } from '@ecs-uk/web-common-mobile-view-helpers';
import DeactivateAccount from '../../deactivate';

interface MobileDeactivatePageProps {
  isFlexUser?: boolean;
}

const MobileDeactivatePage: FC<MobileDeactivatePageProps> = ({ isFlexUser = false }) => {
  useEffect(() => {
    sendMobileLoadedNotification();
  }, []);

  return <DeactivateAccount isWebview useFlexFlow={isFlexUser} />;
};

export default MobileDeactivatePage;
